import {
  faCalendarDays,
  faClock,
  faImage,
  faLocationDot,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useLanguage } from "../../contexts/LanguageContext";
import { formatDisplayDate } from "../../utils/dateUtils";
import EventHeaderMenu from "../EventHeaderMenu/EventHeaderMenu";
import EventStatusBadge from "../EventStatusBadge/EventStatusBadge";

import "./DashboardHeaderInfo.modern.css";

const DashboardHeaderInfo = ({
  event,
  totalPhotos,
  user,
  handleDeleteEvent,
  selectedEventId,
  openEditModal,
  handleQRDownload,
}) => {
  const { t } = useLanguage();
  return (
    <div className="dashboard-header-modern dashboard-header-dashboard dashboard-header-banner-layout">
      {/* Banner superior con info del evento */}
      <div className="dh-banner">
        <div className="dh-banner-content">
          <div className="dh-banner-title-row">
            <span className="dh-banner-title">{event?.name}</span>
            {event && (
              <EventHeaderMenu
                user={user}
                event={event}
                onDeleteEvent={() => handleDeleteEvent(selectedEventId)}
                onEditEvent={openEditModal}
                onDownloadCodeEvent={() =>
                  handleQRDownload(event.qrCode, event.name)
                }
              />
            )}
          </div>
          <div className="dh-banner-meta-row">
            <span className="dh-banner-date">
              <FontAwesomeIcon icon={faCalendarDays} />{" "}
              {formatDisplayDate(event?.date)}
            </span>
            <span className="dh-banner-time">
              <FontAwesomeIcon icon={faClock} /> {event?.time || ""}
            </span>
            {event?.location && (
              <span className="dh-banner-location">
                <FontAwesomeIcon icon={faLocationDot} /> {event.location}
              </span>
            )}
          </div>
          <div className="dh-banner-description">
            {event?.description || ""}
          </div>
          <div
            style={{
              marginTop: "16px",
              marginLeft: "-5px",
            }}
          >
            {event && <EventStatusBadge event={event} />}
          </div>
        </div>
        <div className="dh-cards-row">
          <div className="dh-card metric-card metric-photos">
            <div className="metric-icon">
              <FontAwesomeIcon icon={faImage} />
            </div>
            <div className="metric-value">{totalPhotos}</div>
            <div className="metric-label">{t("dashboard.sidebar.photos")}</div>
          </div>
          <div className="dh-card metric-card metric-guests">
            <div className="metric-icon">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className="metric-value">{event?.totalUsersUploaded || 0}</div>
            <div className="metric-label">{t("dashboard.sidebar.guests")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeaderInfo;
